<div id="content" class="flexColumnContainer">
  <div class="flexColumnContainer justifyContentSpaceBetween">
    <div class="flexRowContainer justifyContentSpaceBetween">
      <p class="headline-small">{{ 'memberOverview.title' | translate }}</p>
      <button mat-flat-button (click)="openInviteMemberDialog()"
              (keydown.enter)="openInviteMemberDialog()" id="addMemberButton">
        <mat-icon class="material-symbols-outlined">person_add</mat-icon>
        <span id="headerButtonText">{{ 'memberOverview.addMemberButton' | translate }}</span>
      </button>
    </div>
    <mat-form-field id="memberSearch" class="m3-search-field" appearance="fill">
      <input #memberSearchInput matInput type="text"
             [placeholder]="'memberOverview.search.placeholder' | translate" aria-label="Search"
             [formControl]="searchMemberShipsControl">
      <mat-icon matPrefix class="material-icons-outlined">search</mat-icon>

      @if (searchMemberShipsControl.value?.length) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          aria-label="Clear search"
          (click)="clearSearch(memberSearchInput)">
          <mat-icon class="material-icons-outlined">close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>
  <section id="tableContainer" [ngClass]="{'loading': loadingMembers}">
    @if (loadingMembers) {
      <div id="matSpinnerContainer">
        <mat-spinner id="loadingSpinner" [diameter]="50"></mat-spinner>
      </div>
    }
    <table id="membershipTable" mat-table [dataSource]="dataSource">
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'memberOverview.table.email' | translate }}</th>
        <td mat-cell class="body-large" *matCellDef="let member">{{ member.email }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>{{ 'memberOverview.table.role' | translate }}</th>
        <td mat-cell class="body-large"
            *matCellDef="let member"> {{ 'memberOverview.table.roles.' + member.role | translate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>{{ 'memberOverview.table.state' | translate }}</th>
        <td mat-cell *matCellDef="let member">
          <span id="stateTag" class="tagRemake"
                [ngClass]="{'success': isActive(member)}">{{ 'memberOverview.table.states.' + getStatus(member.state) | translate }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th id="actionHeader" mat-header-cell *matHeaderCellDef>{{ 'memberOverview.table.action' | translate }}</th>
        <td mat-cell *matCellDef="let member">
          @if (member._links.hasLink('delete')) {
            <button mat-button
                    (click)="openRemoveMemberDialog(member)"
                    (keydown.enter)="openRemoveMemberDialog(member)" class="link">
              {{ 'memberOverview.table.buttons.remove' | translate }}
            </button>
          }
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>
  <mat-paginator
    [pageSize]="memberHal.page.size"
    [pageIndex]="memberHal.page.number"
    [length]="memberHal.page.totalElements"
    [pageSizeOptions]="[5, 10, 20, 40]"
    (page)="updateMemberHal($event)"></mat-paginator>
</div>
